<template>
  <p class="text-red-500 text-xs text-left mb-1">
    {{text}}
  </p>
</template>
<script>
export default {
  name: 'TextError',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Form/TextError.vue